import { Injectable } from "@angular/core";
import AWN from "awesome-notifications";
@Injectable({
  providedIn: 'root'
})
export class CustomNotificationsService {
  globalOptions: {
    labels: {
      tip: "Tip";
      info: "Info";
      success: "Success";
      warning: "Attention";
      alert: "Error";
      async: "Loading";
      confirm: "Confirmation required";
      confirmOk: "YES";
      confirmCancel: "NO";
    };
  };
  notifier: any;
  constructor() {
    this.notifier = new AWN(this.globalOptions);
  }

  success(message) {
    this.notifier = new AWN(this.globalOptions);
    this.notifier.success(message);
    setTimeout(() => this.notifier.closeToasts(), 3000);
  }
  error(message) {
    this.notifier = new AWN(this.globalOptions);
    this.notifier.alert(message);
    setTimeout(() => this.notifier.closeToasts(), 10000);
  }
  info(message) {
    this.notifier = new AWN(this.globalOptions);
    this.notifier.info(message);
    setTimeout(() => this.notifier.closeToasts(), 10000);
  }
  warning(message) {
    this.notifier = new AWN(this.globalOptions);
    this.notifier.warning(message);
    setTimeout(() => this.notifier.closeToasts(), 10000);
  }
  tip(message) {
    this.notifier = new AWN(this.globalOptions);
    this.notifier.tip(message);
    setTimeout(() => this.notifier.closeToasts(), 10000);
  }
  async(successMsg, errorMsg, promise) {
    this.notifier = new AWN(this.globalOptions);
    this.notifier.async(
      promise,
      (resp) => {
        this.notifier.success(successMsg);
        setTimeout(() => this.notifier.closeToasts(), 1000);
      },
      (err) => {
        this.notifier.alert(errorMsg);
        setTimeout(() => this.notifier.closeToasts(), 1000);
      }
    );
  }

  confirm(onOk, onCancel, actionMessage) {
    this.notifier = new AWN(this.globalOptions);
    this.notifier.confirm("Are You Sure?", onOk, onCancel, {
      labels: {
        confirm: actionMessage,
        confirmOk: "YES",
        confirmCancel: "NO",
      },
    });
  }

  confirmDiscard(onOk, onCancel, actionMessage) {
    this.notifier = new AWN(this.globalOptions);
    this.notifier.confirm("", onOk, onCancel, {
      labels: {
        confirm: actionMessage,
        confirmOk: "Save",
        confirmCancel: "Discard",
      },
    });
  }
}
